import loadable from '@loadable/component';

const NewsSyncPage = loadable(() => import('./news-sync/page'));
const DeduplicationPage = loadable(() => import('./deduplication/page'));

export const routes = [
  {
    path: 'news-sync',
    element: <NewsSyncPage />,
  },
  {
    path: 'deduplication',
    element: <DeduplicationPage />,
  },
];
